module.exports = __webpack_public_path__ + "bfa4544b9a05c6704c7272daa361e82c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/microsoft_2023_chart.png
// module id = 1698
// module chunks = 0